var _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 14.575009999999999 14.575",
    width: 14.575009999999999,
    height: 14.575,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(172, 187, 199)"
    },
    d: "M10.41667,9.16667h-0.65833l-0.23333,-0.225c0.81667,-0.95 1.30833,-2.18333 1.30833,-3.525c0,-2.99167 -2.425,-5.41667 -5.41667,-5.41667c-2.99167,0 -5.41667,2.425 -5.41667,5.41667c0,2.99167 2.425,5.41667 5.41667,5.41667c1.34167,0 2.575,-0.49167 3.525,-1.30833l0.225,0.23333v0.65833l4.16667,4.15833l1.24167,-1.24167zM5.41667,9.16667c-2.075,0 -3.75,-1.675 -3.75,-3.75c0,-2.075 1.675,-3.75 3.75,-3.75c2.075,0 3.75,1.675 3.75,3.75c0,2.075 -1.675,3.75 -3.75,3.75z",
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-16586963510156778",
    d: "M10.41667,9.16667h-0.65833l-0.23333,-0.225c0.81667,-0.95 1.30833,-2.18333 1.30833,-3.525c0,-2.99167 -2.425,-5.41667 -5.41667,-5.41667c-2.99167,0 -5.41667,2.425 -5.41667,5.41667c0,2.99167 2.425,5.41667 5.41667,5.41667c1.34167,0 2.575,-0.49167 3.525,-1.30833l0.225,0.23333v0.65833l4.16667,4.15833l1.24167,-1.24167zM5.41667,9.16667c-2.075,0 -3.75,-1.675 -3.75,-3.75c0,-2.075 1.675,-3.75 3.75,-3.75c2.075,0 3.75,1.675 3.75,3.75c0,2.075 -1.675,3.75 -3.75,3.75z",
    vectorEffect: "non-scaling-stroke"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.3dec172a.svg";
export { ForwardRef as ReactComponent };